import { cn } from '@dreamstack/util/src/cn'
import React from 'react'

type PageBlockSpacingContainerProps = React.PropsWithChildren<{
  className?: string
}>

export const PageBlockSpacingContainer: React.FC<
  PageBlockSpacingContainerProps
> = ({ children, className }) => {
  return (
    <div
      className={cn(
        'space-y-px-64 mt-px-64',
        'ml:space-y-px-96 ml:mt-px-96',
        'lg:space-y-px-96 lg:mt-px-96',
        className
      )}
    >
      {children}
    </div>
  )
}
